import { createGlobalStyle } from "styled-components";

/** CSS animations used by UI components.
 *
 * Will be injected into the DOM by the `ThemeProvider` component.
 */
export const GlobalStyles = createGlobalStyle`

  @keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes pulse {
  50% {
    opacity: 1;
  }
}
`;
